import { h, VNode, Fragment, ComponentChildren, FunctionComponent, toChildArray } from "preact"; /** @jsx h */
import { clsx } from 'clsx';

export type IColumnProps = {
    children?: ComponentChildren;
    
};


export const Column = (props: IColumnProps) => {

    return (
        <Fragment>
            {
                toChildArray(
                    props.children
                )//.filter((child: any) => child?.type?.name == "Column")
            }   
        </Fragment>

    );
}